function createMarkup(input) {
  return {
    __html: input
  };
}
export { createMarkup };
